import React, { useEffect, useState } from 'react';
import Icon from 'screens/shared/icon';
import { isEmptyArray, _t, objectExistsInArray } from 'utils';
import Form from './index';
import CardBasic from '../card-basic';

export default ({
  fields,
  validations,
  value,
  onChange,
  onEdit,
  onEditCancel,
  setItemTitle,
  setItemDetails,
  icon = '',
  actionButtonName = '',
  title = '',
  subTitle = '',
  error = '',
  isAddButton = false,
  maxItems = 1000,
  changeFields = [],
  initValues = {},
  isChild,
  editable,
  deletable = true,
  elementCount,
  uniqueValues,
  refresh: initRefresh = 0,
  validateOnBlur,
  propagateValidation,
  onChangeSetInitValues,
}) => {
  const [refresh, doRefresh] = useState(initRefresh);
  const [values, setValues] = useState(value || []);
  const [formValue, setFormValue] = useState({ ...initValues });
  const [isForm, setIsForm] = useState(!isAddButton);
  const [editValue, setEditValue] = useState(false);
  const [submitDisabled, setSubmitDisabled] = useState(false);

  useEffect(() => {
    setValues(value);
    // eslint-disable-next-line
  }, [value]);

  const handleEdit = (val, index) => {
    setEditValue({ value: val, index });

    if (onEdit) {
      onEdit(val);
    }
  };

  const handleCancel = () => {
    setEditValue(false);
    setFormValue({ ...initValues });
    doRefresh((prev) => prev + 1);

    if (onEditCancel) {
      onEditCancel();
    }
  };

  useEffect(() => {
    if (isChild) {
      handleCancel();
    }
    // eslint-disable-next-line
  }, [initRefresh]);

  const submitHandler = (e) => {
    let newValues = values;
    if (editValue) {
      newValues[editValue.index] = e;
      handleCancel();
    } else {
      newValues = [...values, e];
    }
    setValues(newValues);
    if (isAddButton) setIsForm(false);
    setFormValue({ ...initValues });
    if (propagateValidation) propagateValidation({ ...e });
    onChange(newValues);
  };

  const handleDelete = (index) => {
    const newValues = [...values];
    newValues.splice(index, 1);
    setValues(newValues);
    onChange(newValues);
  };

  const handleChange = (e) => {
    let val = { ...e };
    if (onChangeSetInitValues) {
      val = { ...val, ...onChangeSetInitValues(e, formValue) };
    }
    setFormValue(val);
    if (uniqueValues) {
      const foundValue = objectExistsInArray(e, values);
      setSubmitDisabled(!!foundValue);
    }
  };

  const isMoreItems = !!editValue || isEmptyArray(values) || maxItems > values.length;

  return (
    <>
      <div className={`form-field ${error ? 'form-field-error' : ''}`}>
        {!!title && (
          <p className="form-field-title color-base">
            <span>{title}</span>
            {(isMoreItems && isAddButton) && (
              <span className="circle-button cards-icon relative top-5-" onClick={() => setIsForm(!isForm)}>
                <Icon name="plus" />
                {_t('Add')}
              </span>
            )}
          </p>
        )}
        {!!subTitle && <p className="form-field-sub-title">{subTitle}</p>}
        {elementCount && <p className="form-field-sub-title">{`${values.length} ${_t('COMMON.LABELS.OUT_OF')} ${elementCount}`}</p>}
        {isMoreItems && (isForm || editValue) && (
          <Form
            fields={fields}
            fieldsValues={editValue ? editValue.value : formValue}
            validations={validations}
            onSubmit={submitHandler}
            onCancel={handleCancel}
            submitTitle={editValue ? _t('Edit') : (actionButtonName || _t('Add'))}
            onChange={handleChange}
            onProps={editValue ? editValue.value : formValue}
            cancelTitle={_t('Cancel')}
            isActionButtons={isMoreItems}
            changeFields={changeFields}
            isCancel={!!editValue}
            isChild
            refresh={refresh}
            submitDisabled={submitDisabled}
            validateOnBlur={validateOnBlur}
          />
        )}
        {!!values.length && (
          <div className="m-b-10 m-t-25">
            {values.map((e, i) => (
              <CardBasic
                key={i}
                icon={icon}
                iconFill="var(--color-base)"
                title={setItemTitle?.(e)}
                details={setItemDetails?.(e)}
                actionButtons={{
                  edit: editable ? () => handleEdit(e, i) : null,
                  delete: deletable ? () => handleDelete(i) : null,
                }}
              />
            ))}
          </div>
        )}
      </div>
      {error && <span className="field-error-helper" style={{ marginBottom: 10, display: 'block' }}>{error}</span>}
    </>
  );
};
